import gql from "graphql-tag";

export const MY_HR_USER_SUBSCRIPTION = gql`
  subscription usersSubscription {
    usersSubscription
  }
`;
